import { useNavigate, useParams } from 'react-router-dom'

import {
  TrainingClassMaterialsDocument,
  TrainingClassMaterialsNewFileModalDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { NewFileModal } from 'modules/trainings/components/Files/NewFileModal'
import type { FileSubmissionData } from 'modules/trainings/components/Files/NewFileModal/types'

export default function TrainingClassMaterialsNewFileModal() {
  const navigate = useNavigate()
  const { access } = useCurrentSession()
  const { classId, id } = useParams<{ id: string; classId: string }>()
  const { navigation } = useNavigation()
  const [createDocument] = useMutation(TrainingClassMaterialsNewFileModalDocument, {
    extractorFn: (data) => data.trainingsMutations.createTrainingsTrainingClassFile,
    awaitRefetchQueries: true,
    refetchQueries: [TrainingClassMaterialsDocument],
  })

  return (
    <NewFileModal
      onClose={() =>
        navigate(
          navigation.trainings.list.details_revamp.view.trainingClasses.detail.materials.fullPath({
            id: Number(id),
            classId: Number(classId),
          })
        )
      }
      onSubmit={async (data: FileSubmissionData) => {
        const result = await createDocument({
          variables: {
            trainingClassId: Number(classId),
            authorId: access.id,
            visibility: true,
            title: data.title,
            file: data.type === 'file' ? data.file : undefined,
            signedId: data.type === 'signedId' ? data.signedId : undefined,
          },
        })
        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('trainings.trainings_files_modal.create_error'),
          })
        })
        if (handled.success) {
          navigate(
            navigation.trainings.list.details_revamp.view.trainingClasses.detail.materials.fullPath(
              {
                id: Number(id),
                classId: Number(classId),
              }
            )
          )
        }
      }}
      resourceId={classId}
      resourceType="Trainings::TrainingClass"
      title={i18n.t('trainings.trainings_revamp.classes.materials.new_file_modal.title')}
      description={i18n.t(
        'trainings.trainings_revamp.classes.materials.new_file_modal.description'
      )}
    />
  )
}
